import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../CSS/Layout.css';

import layout1 from '../assets/LIBRA EVENTS/KSH_0837.jpg';
import layout2 from '../assets/LIBRA EVENTS/KSH_9661.jpg';
import layout3 from '../assets/LIBRA EVENTS/WhatsApp Image 2024-02-03 at 10.36.56 AM (1).jpeg';

const Layout = () => {
  const [selectedLayout, setSelectedLayout] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const message = `*Venue Booking Request*\n\n*Name:* ${formData.name}\n*Email:* ${formData.email}\n*Phone:* ${formData.phone}\n*Message:* ${formData.message}`;
    const phoneNumber = '919909254684';
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, '_blank');

    setShowModal(false);
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  const layouts = [
    {
      id: 1,
      name: 'Lilac Banquet Hall',
      image: layout1,
      description: 'Elegant venue with modern facilities',
      features: [
        { icon: '🎉', text: '100 Guests Capacity' },
        { icon: '🌐', text: 'Wi-Fi Available' },
        { icon: '🅿️', text: 'Free Parking' },
      ],
    },
    {
      id: 2,
      name: 'Lily Banquet Hall',
      image: layout2,
      description: 'A classic space for beautiful events',
      features: [
        { icon: '🎉', text: '500 Guests Capacity' },
        { icon: '🌸', text: 'Decor Included' },
        { icon: '🎵', text: 'DJ & Music' },
        { icon: '🌐', text: 'Wi-Fi Available' },
      ],
    },
    {
      id: 3,
      name: 'Lotus Banquet Hall',
      image: layout3,
      description: 'Perfect for grand weddings and parties',
      features: [
        { icon: '🎉', text: '500 Guests Capacity' },
        { icon: '🌸', text: 'Decor Included' },
        { icon: '🎵', text: 'DJ & Music' },
        { icon: '🌐', text: 'Wi-Fi Available' },
      ],
    },
  ];

  return (
    <section className="layout-section">
      <h2 className="layout-heading">Our Layouts</h2>

      <div className="layout-grid">
        {layouts.map((layout) => (
          <div
            key={layout.id}
            className={`layout-card ${selectedLayout === layout.id ? 'selected' : ''}`}
            onClick={() => setSelectedLayout(layout.id)}
          >
            <div className="layout-image-container">
              <img
  src={layout.image}
  alt={layout.name}
  className={`layout-image ${layout.id <= 3 ? 'blurred' : ''}`}
/>

              <div className="layout-overlay"></div>
              <div className="layout-text-overlay">
                <h3>{layout.name}</h3>
                <p>{layout.description}</p>
              </div>
            </div>

            <div className="layout-details">
              <div className="layout-features">
                {layout.features.map((feature, index) => (
                  <div key={index} className="layout-feature-item">
                    <span className="layout-feature-icon">{feature.icon}</span>
                    <span className="layout-feature-text">{feature.text}</span>
                  </div>
                ))}
              </div>
              <div className="layout-divider"></div>
              <div className="layout-buttons">
                <Link
                  to={
                    layout.id === 1
                      ? '/Lilac'
                      : layout.id === 2
                      ? '/Lily'
                      : '/Lotus'
                  }
                >
                  <button className="layout-know-more-btn">Know More</button>
                </Link>
                <button className="layout-book-btn" onClick={() => setShowModal(true)}>
                  Book Now
                </button>
              </div>
            </div>
          </div>
        ))}

        {/* ✅ New Combined Layout Card */}
        <div className="layout-card special">
          <div className="layout-image-container">
<img src={layout2} alt="Combined Hall" className="layout-image blurred" />

            <div className="layout-overlay"></div>
            <div className="layout-text-overlay">
              <h3>Combined Lily + Lotus Hall</h3>
              <p>Massive space for large events and weddings</p>
            </div>
          </div>

          <div className="layout-details">
            <div className="layout-features">
  <div className="layout-feature-item">
    <span className="layout-feature-icon">🎉</span>
    <span className="layout-feature-text">Up to 1000 Guests</span>
  </div>
  <div className="layout-feature-item">
    <span className="layout-feature-icon">🔗</span>
    <span className="layout-feature-text">
      Lily and Lotus Banquet Halls can be merged into one large hall
    </span>
  </div>
  <div className="layout-feature-item">
    <span className="layout-feature-icon">🌐</span>
    <span className="layout-feature-text">High-Speed Wi-Fi for Events</span>
  </div>
  <div className="layout-feature-item">
    <span className="layout-feature-icon">🎤</span>
    <span className="layout-feature-text">In-house Sound and Lighting System</span>
  </div>
</div>

            <div className="layout-divider"></div>
            <p style={{ color: '#ffd700', fontStyle: 'italic', marginBottom: '1rem' }}>
              If guest capacity is higher, we can combine Lily and Lotus to create a single grand venue
              accommodating up to 1000 guests comfortably.
            </p>
            <div className="layout-buttons">
              <button className="layout-book-btn" onClick={() => setShowModal(true)}>
                Book Now
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <h3 style={{ color: 'black' }}>Book Now</h3>
            <form className="modal-form" onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Your Name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
              />
              <input
                type="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
              />
              <input
                type="tel"
                placeholder="Your Phone"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                required
              />
              <textarea
                placeholder="Message / Special Requests"
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              ></textarea>
              <div className="modal-actions">
                <button type="submit" className="submit-btn">Send</button>
                <button type="button" className="close-btn" onClick={() => setShowModal(false)}>Close</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
};

export default Layout;
